import request from '@/utils/httpRequest'
/*
 * @author: xz
 * @date: 2021/04/29
 * */
/*
 * @Description: 活动列表
 * */
export function getAppointmentList (query) {
  return request({
    url: '/api/activity/web/page',
    method: 'get',
    params: query
  })
}
/*
 * @Description: 活动详情
 * */
export function getAppointmentDetail (id) {
  return request({
    url: '/api/activity/web/' + id,
    method: 'get'
  })
}
/*
 * @Description: 活动场次
 * */
export function getAppointmentSession (id) {
  return request({
    url: '/api/activity/web/session/' + id,
    method: 'get'
  })
}
/*
 * @Description: 联系人列表
 * */
export function getAppointmentContactsList (userName, code) {
  return request({
    url: '/api/activity/ta/contactsList/' + userName + '/' + code,
    method: 'get'
  })
}
/*
 * @Description: 添加联系人
 * */
export function addAppointmentContacts (query) {
  return request({
    url: '/api/activity/ta/contacts/add',
    method: 'post',
    data: query
  })
}

/*
 * @Description: 删除联系人
 * */
export function deleteAppointmentContacts (id) {
  return request({
    url: '/api/activity/ta/contacts/' + id,
    method: 'delete'
  })
}
/*
 * @Description: 活动报名
 * */
export function getAppointmentsignUp (query) {
  return request({
    url: '/api/activity/ta/signUp',
    method: 'put',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/appointment/index.js